import { lazy, Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Index from "./pages/Index";

// Lazy load toast components to reduce initial bundle size
const Toaster = lazy(() => import("@/components/ui/toaster").then(m => ({ default: m.Toaster })));
const Sonner = lazy(() => import("@/components/ui/sonner").then(m => ({ default: m.Toaster })));
const TooltipProvider = lazy(() => import("@/components/ui/tooltip").then(m => ({ default: m.TooltipProvider })));

// Lazy load non-critical routes to reduce initial bundle size
const Auth = lazy(() => import("./pages/Auth"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Assets = lazy(() => import("./pages/Assets"));
const Admin = lazy(() => import("./pages/Admin"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Terms = lazy(() => import("./pages/Terms"));
const Cookies = lazy(() => import("./pages/Cookies"));
const ESG = lazy(() => import("./pages/ESG"));
const ModernSlavery = lazy(() => import("./pages/ModernSlavery"));
const RiskDisclosure = lazy(() => import("./pages/RiskDisclosure"));
const ComplaintsHandling = lazy(() => import("./pages/ComplaintsHandling"));
const Contact = lazy(() => import("./pages/Contact"));
const TokenEconomics = lazy(() => import("./pages/TokenEconomics"));
const InvestmentPhilosophy = lazy(() => import("./pages/InvestmentPhilosophy"));
const StructureDiscipline = lazy(() => import("./pages/StructureDiscipline"));
const StewardshipScale = lazy(() => import("./pages/StewardshipScale"));
const Legal = lazy(() => import("./pages/Legal"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={null}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <ScrollToTop />
            <Suspense fallback={<div className="min-h-screen bg-background" />}>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/assets" element={<Assets />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/cookies" element={<Cookies />} />
                <Route path="/esg" element={<ESG />} />
                <Route path="/modern-slavery" element={<ModernSlavery />} />
                <Route path="/risk-disclosure" element={<RiskDisclosure />} />
                <Route path="/complaints-handling" element={<ComplaintsHandling />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/token-economics" element={<TokenEconomics />} />
                <Route path="/investment-philosophy" element={<InvestmentPhilosophy />} />
                <Route path="/structure-discipline" element={<StructureDiscipline />} />
                <Route path="/stewardship-scale" element={<StewardshipScale />} />
                <Route path="/legal" element={<Legal />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </TooltipProvider>
      </Suspense>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
